/*
 * vrtPSTester.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSTester: RouteRecordRaw = {
  path: '/powersteer/tester',
  name: 'vrtPSTester',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // {
    //   path: 'create',
    //   name: 'vrtPOWERsteerCreate',
    //   component: () => import('./vpgPOWERsteerCreate.vue'),
    // },
    // {
    //   path: 'read',
    //   name: 'vrtPOWERsteerRead',
    //   component: () => import('./vpgPOWERsteerRead.vue'),
    // },
  ],
};

export default vrtPSTester;
